<template>
	<div>
		<textarea
			v-if="input.type == 'textarea'"
			v-model="input.value"
			class="form-control"
			:disabled="input.disabled"
			:rows="input.qntRows"
		></textarea>
	</div>
</template>
<script>
	export default {
		name: 'ChTextarea',
		props: ['data'],
		computed: {
			input() {
				return this.data;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/models/create-form/inputs/chTextarea.vue